export default ({data, onClick2, flight}) => {

    return (

    <div className="continer-projects-aufa-project" onClick={() => {onClick2(data.name)}}>
        <p> {data.name} </p>
        {flight ?

        <div>
            <p>מס' טיסות הלוך: <span> {data["flights"]["A"]} </span> </p>
            <p>מס' טיסות חזור: <span> {data["flights"]["R"]} </span></p>
            <p>מס' טיסות הלוך חזור: <span> {Math.floor(data["flights"]["B"] / 2)} </span></p>
            {/* <p> מס' טיסות מבצעים מיוחדים: <span> {data.S} </span></p> */}
        </div> :

        <div>
            <p>מס' נסיעות פנים הלוך: <span> {data["cars"]["A"]} </span> </p>
            <p>מס' נסיעות פנים חזור: <span> {data["cars"]["A"]} </span> </p>
        </div>
        }
    </div>

    )
}